import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { cloneDeep } from 'lodash';
import {
  CommonRegEx,
  DialogService,
  DropDownData,
  EntityCacheProvider,
  UrlValidationService,
  IApplication
} from '@nrwl/common-lib';
import { HttpClient } from '@angular/common/http';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'add-application',
  templateUrl: './add-application.component.html',
  styleUrls: ['./add-application.component.scss']
})
export class AddApplicationComponent implements OnInit, OnChanges {
  @Input() selApp: DropDownData;
  @Output() applicationAdded: EventEmitter<IApplication> = new EventEmitter();
  @Output() closeWindow: EventEmitter<boolean> = new EventEmitter(false);
  editMode: boolean;
  formApplication = new UntypedFormGroup({
    name: new UntypedFormControl('', Validators.required),
    url: new UntypedFormControl('', Validators.required)
  });
  createApplication = '/entity/v1/application';
  formData: {
    name: string;
    url: string;
    curlUrl?: string;
  };
  isChecked = false;
  isValidUrl = false;
  apps: IApplication[];
  names: string[];
  urls: string[];
  urlValidationWarningMessage = '';
  inputDisable = false;
  buttonEnable = true;
  constructor(
    private readonly httpClient: HttpClient,
    private urlValidationService: UrlValidationService,
    private readonly dialogService: DialogService,
    private entityCache: EntityCacheProvider
  ) {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  ngOnInit(): void {
    this.apps = this.getApps();
    this.names = this.apps.map(a => a.name).filter(name => !!name);
    this.urls = this.apps.map(a => a.url).filter(url => !!url);
    this.formApplication.get('name').valueChanges.subscribe(selectedValue => {
      if (selectedValue) {
        if (
          this.names.some(url => url.trim().toLowerCase() === selectedValue.trim().toLowerCase())
        ) {
          this.formApplication.get('name').setErrors({ isUnique: true });
        }
      }
    });
    this.formApplication.get('url').valueChanges.subscribe(selectedUrl => {
      if (selectedUrl) {
        const urlValidation = this.urlValidationService.isUrlValid(selectedUrl);
        this.isValidUrl = urlValidation.isValidUrl;
        this.urlValidationWarningMessage = urlValidation.errorMessage;
        if (
          this.names.some(name => name.trim().toLowerCase() === selectedUrl.trim().toLowerCase())
        ) {
          this.formApplication.get('url').setErrors({ isUnique: true });
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.selApp.currentValue &&
      changes.selApp.currentValue.key !== '' &&
      changes.selApp.currentValue.value !== ''
    ) {
      this.formApplication.disable();
      this.formApplication.controls['name'].disable();
      this.formApplication.controls['url'].disable();
      this.inputDisable = true;
    } else {
      this.formApplication.enable();
      this.formApplication.controls['name'].enable();
      this.formApplication.controls['url'].enable();
      this.inputDisable = false;
    }
  }

  getApps(): IApplication[] {
    const cachedApps = this.entityCache.findEntityCache('application');
    const filteredData = cachedApps.getValues().map(a => a.applicationData);
    return filteredData.filter(app => !app.deleted);
  }

  public resetURLvalues(): void {
    this.formApplication.get('url').setValue('');
    if (this.isChecked) {
      this.isValidUrl = true;
      this.formApplication.addControl('curlUrl', new UntypedFormControl(''));
    } else {
      this.formApplication.removeControl('curlUrl');
    }
  }

  createNewApplication(): void {
    this.buttonEnable = false;
    this.formData = cloneDeep(this.formApplication.value);
    if (this.isChecked && this.formApplication.controls['curlUrl']?.value) {
      const urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
      const availableUrls = this.formApplication.controls['curlUrl'].value.match(urlRegex);
      this.formData.url = availableUrls?.[0].replace(/["']/g, '') || '';
      this.formData.curlUrl = btoa(this.formData.curlUrl);
    } else {
      const re = new RegExp(CommonRegEx.URL_START_REGEX, 'i');
      if (this.formData.url && !re.test(this.formData.url)) {
        this.formData.url = 'http://' + this.formData.url;
      }
    }
    this.httpClient.post(this.createApplication, this.formData).subscribe(
      (app: IApplication) => {
        this.formApplication.reset();
        this.applicationAdded.emit(app);
        this.dialogService.showInfo('information', 'body', 'Application added !', 'Application');
        this.buttonEnable = true;
      },
      msgErr => {
        const errorMsg = msgErr.error?.errors?.[0] || msgErr.error;
        this.dialogService.showInfo('information', 'body', errorMsg, 'Application');
        this.buttonEnable = true;
      }
    );
  }

  newAppButtonEnable(): boolean {
    if (
      this.buttonEnable &&
      this.isValidUrl &&
      this.formApplication.get('name')?.value &&
      this.formApplication.get('name').valid &&
      ((this.formApplication.get('url')?.value && this.formApplication.get('url').valid) ||
        (this.formApplication.get('curlUrl')?.value && this.formApplication.get('curlUrl').valid))
    ) {
      return false;
    }
    return true;
  }
  close(): void {
    this.closeWindow.emit(true);
  }
}
